<template>
    <b-card v-if="this.i18data && this.i18data.descriptions">
        <h4>
            Event description
            <b-badge style="float: right"
                v-if="!languages || languages.length &lt; 2">
                <i class="fa fa-id-card-o"></i>
            </b-badge>
            <b-dropdown split style="float: right"
                v-if="languages && languages.length &gt; 1">
                <template slot="button-content">
                    <i class="fa fa-globe" style="font-size: larger"></i>
                </template>
                <b-dropdown-item v-for="l in languages" v-bind:key="l"
                    :selected="selectedLanguage == l"
                    @click="selectedLanguage = l">
                    {{l}}
                </b-dropdown-item>
            </b-dropdown>
        </h4>
        
        <b-card-body>
            {{description}}
        </b-card-body>
    </b-card>
</template>

<script>
import axios from "axios";

export default {
    name: "eventDescription",
    props: ["event_id"],
    data: () => {
        return {
            resources: {
                events: "/events",
                descriptions: "/descriptions"
            },
            i18data: {},
            selectedLanguage: null
        };
    },
    methods: {
        fetchData(resource, options) {
            return axios
                .get(this.$store.getters.apiBase + this.$data.resources.events + "/" + this.$props["event_id"] +  this._data.resources.descriptions, {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
                    }
                })
                .then(response => {
                    this.$data.i18data = response.data;
                    return response;
                })
                .catch(response => {
                    console.log(response);
                });
        }
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        languages() {
            const lng = [];
            if (this.$parent.event.languages) {
                for (let l of this.$parent.event.languages) {
                    lng.push(l.substring(0, 2));
                    this.selectedLanguage = this.selectedLanguage || l;
                }
            }
            return lng;
        },
        description() {
            let ret = null;
            if (this.selectedLanguage && this.i18data && this.i18data.descriptions && this.i18data.descriptions.i18) {
                ret = this.i18data.descriptions.i18[this.selectedLanguage];
            }
            return ret;
        }
    },
    created() {
        this.fetchData();
    }
};
</script>